class Amplifier {
    constructor(data = {}) {
        this.id = data.id || null;
        this.name = data.dS_NOME || '';
        this.serialNumber = data.dS_DL || '';
        this.location = data.dS_LOCALIZACAO || '';
        this.groupId = data.fK_VL_CADASTR_GRUPO || '';
        this.panelSerial = data.fK_CENTRAL_AMPLIFICADOR || '';
        this.status = data.dS_STATUS || 'offline';
        this.metrics = {
            battery: data.vL_BATERIA || 0,
            power: data.vL_FONTE || 0,
            signal: data.vL_SINAL || 0,
            lastUpdate: data.dT_AMPLIFICADOR ? new Date(data.dT_AMPLIFICADOR) : new Date()
        };
        this.network = {
            myAddress: data.dS_MY || '',
            dhAddress: data.dS_DH || '',
            dlAddress: data.dS_DL || ''
        };
        this._pendingChanges = new Map();
    }

    // Getters
    getId() { return this.id; }
    getName() { return this.name; }
    getSerialNumber() { return this.serialNumber; }
    getLocation() { return this.location; }
    getGroupId() { return this.groupId; }
    getStatus() { return this.status; }
    
    getFullLocation() { 
        const location = `${this.groupId.slice(12)} - ${this.location}`;
        const parts = location.split(" - ");
        return parts[1] === "" ? `${parts[0]} - Sem Nome Registrado` : location; 
    }

    // Métodos de Estado
    isOnline() {
        return this.status === 'online';
    }

    isSyncing() {
        return this.status === 'buscando';
    }

    isOffline() {
        return this.status === 'offline';
    }

    isSpecialEquipment() {
        return this.name === 'Central' || this.name === 'Modem';
    }

    isNotTracked() {
        return this.network.dhAddress.includes('a201');
    }

    // Métodos de Atualização
    setName(newName) {
        if (newName !== this.name) {
            this._pendingChanges.set('name', newName);
            this.name = newName;
        }
    }

    setGroup(groupId, location) {
        this._pendingChanges.set('group', { groupId, location });
        this.groupId = groupId;
        this.location = location;
        this.network.dhAddress = "0013a200";
    }

    setStatus(newStatus) {
        if (newStatus !== this.status) {
            this.status = newStatus;
        }
    }

    updateMetrics(battery, power, signal) {
        this.metrics = {
            ...this.metrics,
            battery: battery || this.metrics.battery,
            power: power || this.metrics.power,
            signal: signal || this.metrics.signal,
            lastUpdate: new Date()
        };
    }

    // Controle de Mudanças Pendentes
    hasPendingChanges() {
        return this._pendingChanges.size > 0;
    }

    getPendingChanges() {
        return this._pendingChanges;
    }

    clearPendingChanges() {
        this._pendingChanges.clear();
    }

    // Conversão para formato do backend
    toDatabase() {
        return {
            ID: this.id,
            DS_NOME: this.name,
            DS_NUMSERIE: `${this.network.dhAddress}${this.network.dlAddress}`,
            DS_LOCALIZACAO: this.location || '',
            FK_VL_CADASTR_GRUPO: this.groupId,
            FK_CENTRAL_AMPLIFICADOR: this.panelSerial,
            DS_STATUS: this.status,
            VL_BATERIA: this.metrics.battery,
            VL_FONTE: this.metrics.power,
            VL_SINAL: this.metrics.signal,
            DS_MY: this.network.myAddress,
            DS_DH: this.network.dhAddress,
            DS_DL: this.network.dlAddress,
            DT_AMPLIFICADOR: this.metrics.lastUpdate.toISOString(),
            STATUS: []
        };
    }

    // Método específico para atualização de nome
    toDatabaseForNameUpdate() {
        return {
            ...this.toDatabase(),
            DS_DH: '0013a200', // Garantindo o valor padrão como no C#
            DS_NUMSERIE: `0013a200${this.serialNumber}` // Garantindo o formato correto
        };
    }

    // Criação a partir de dados do backend
    static fromDatabase(data) {
        // Garante que temos um objeto válido
        if (!data || typeof data !== 'object') {
            console.warn('Dados inválidos recebidos para criar Amplifier:', data);
            data = {};
        }
        
        // Passa os dados diretamente, pois o construtor já lida com os nomes corretos
        return new Amplifier(data);
    }
}

export default Amplifier;